// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1BTLd","header":"PatientQuestionnaire_header__s4xaN","info":"PatientQuestionnaire_info__1eLUo"};